import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

export class ISpinnerOptions extends DOMRect {
    size: 'small' | 'medium' | 'big' | 'giant';
}

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class SpinnerComponent implements OnInit {

    height = '10rem';
    private _options: ISpinnerOptions;
    set options(data: ISpinnerOptions) {
        if (data) {
            this._options = data;

        }
    }

    ngOnInit() {
        this.height = this._options.size === 'small'
            ? '5rem' : this._options.size === 'medium'
                ? '10rem' : this._options.size === 'big'
                    ? '15rem' : this._options.size === 'giant'
                        ? '20rem' : this.height;
    }
}
